import React, { memo } from "react";
import Link from "next/link";
import {
  FacebookFillIcon,
  InstagramFillIcon,
  TwitterFillIcon,
  YouTubeFillIcon,
  WebsiteFillIcon,
} from "components/Icons/Social.icons";
import { PublicLinks } from "types/business.types";
import useTranslation from "next-translate/useTranslation";

type Props = { businessName: string; publicLinks: PublicLinks };

function Socials({ publicLinks }: Props) {
  const { t } = useTranslation("common");
  return (
    <div className="flex items-center mt-4 flex-wrap md:gap-3 gap-4">
      {publicLinks?.twitter && (
        <Link
          className="p-1 w-[46px] h-[46px] flex items-center justify-center transition-colors border rounded-lg border-zinc-200 hover:bg-zinc-200 focus:outline-none focus:ring-2 focus:ring-zinc-200"
          href={publicLinks.twitter}
          target={"_blank"}
          role="link"
          aria-label="Twitter"
          rel="nofollow"
        >
          <TwitterFillIcon className="rounded-lg h-[24px]" />
        </Link>
      )}

      {publicLinks?.youtube && (
        <Link
          className="block p-1 transition-colors border rounded-lg border-zinc-200 hover:bg-zinc-200 focus:outline-none focus:ring-2 focus:ring-zinc-200"
          href={publicLinks.youtube}
          target={"_blank"}
          role="link"
          aria-label="YouTube"
          rel="nofollow"
        >
          <YouTubeFillIcon className="rounded-lg h-10 md:h-9" />
        </Link>
      )}

      {publicLinks?.instagram && (
        <Link
          className="block p-1 transition-colors border rounded-lg border-zinc-200 hover:bg-zinc-200 focus:outline-none focus:ring-2 focus:ring-zinc-200"
          href={publicLinks.instagram}
          target={"_blank"}
          role="link"
          aria-label="Instagram"
          rel="nofollow"
        >
          <InstagramFillIcon className="rounded-lg h-10 md:h-9" />
        </Link>
      )}

      {publicLinks?.facebook && (
        <Link
          className="block p-1 transition-colors border rounded-lg border-zinc-200 hover:bg-zinc-200 focus:outline-none focus:ring-2 focus:ring-zinc-200"
          href={publicLinks.facebook}
          target={"_blank"}
          role="link"
          aria-label="Facebook"
          rel="nofollow"
        >
          <FacebookFillIcon className="rounded-lg h-10 md:h-9" />
        </Link>
      )}

      {/* <Link
					className="block hover:opacity-75 transition-opacity text-[#0A66C2]"
					href="https://twitter.com"
					target={"_blank"}
					role="link"
					aria-label="LinkedIn"
				>
					<LinkedInIcon className="rounded-lg h-10 md:h-9" />
				</Link> */}

      {publicLinks?.website && (
        <Link
          className="flex items-center p-1 pr-3 transition-colors border rounded-lg border-zinc-200 hover:bg-zinc-200 focus:outline-none focus:ring-2 focus:ring-zinc-200"
          href={publicLinks.website}
          target={"_blank"}
          role="link"
          aria-label="Website"
          rel="nofollow"
        >
          <WebsiteFillIcon className="rounded-lg h-10 md:h-9 text-zinc-500" />
          <span className="uppercase ml-1 text-[#505A69] text-sm font-medium">
            {t("social.website")}
          </span>
        </Link>
      )}
    </div>
  );
}

export default memo(Socials);
